"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPlaygroundTouchesToBitMoves = void 0;
const rxjs_1 = require("rxjs");
function mapPlaygroundTouchesToBitMoves(threshold) {
    let lastValue = Infinity;
    let previousX = -99;
    let previousY = -99;
    return function (source) {
        return source.pipe((0, rxjs_1.scan)(function (acc, curr) {
            if (acc === undefined) {
                return {
                    ...curr,
                    lastX: curr.startX,
                    lastY: curr.startY
                };
            }
            if (acc.cordStartX !== curr.cordStartX
                || acc.cordStartY !== curr.cordStartY
                || acc.startX !== curr.startX
                || acc.startY !== curr.startY) {
                return {
                    ...curr,
                    lastX: curr.startX,
                    lastY: curr.startY
                };
            }
            if (curr.x - threshold > acc.lastX) {
                return {
                    ...curr,
                    lastX: curr.x,
                    lastY: curr.y,
                    moveDetected: { x: 1, y: 0, w: 1, h: 1 }
                };
            }
            if (curr.x + threshold < acc.lastX) {
                return {
                    ...curr,
                    lastX: curr.x,
                    lastY: curr.y,
                    moveDetected: { x: -1, y: 0, w: 1, h: 1 }
                };
            }
            if (curr.y - threshold > acc.lastY) {
                return {
                    ...curr,
                    lastX: curr.x,
                    lastY: curr.y,
                    moveDetected: { x: 0, y: 1, w: 1, h: 1 }
                };
            }
            if (curr.y + threshold < acc.lastY) {
                return {
                    ...curr,
                    lastX: curr.x,
                    lastY: curr.y,
                    moveDetected: { x: 0, y: -1, w: 1, h: 1 }
                };
            }
            return acc;
        }, undefined), (0, rxjs_1.map)(v => v.moveDetected), (0, rxjs_1.filter)(Boolean), (0, rxjs_1.distinctUntilChanged)(function (a, b) {
            const now = Date.now();
            if (lastValue + 250 < now) {
                lastValue = now;
                previousX = b.x;
                previousY = b.y;
                return false;
            }
            const differentMoveDirection = a.x !== b.x || a.y !== b.y;
            const notReversing = b.x !== -previousX || b.y !== -previousY;
            if (differentMoveDirection && notReversing) {
                lastValue = now;
                previousX = b.x;
                previousY = b.y;
                return false;
            }
            return true;
        }));
    };
}
exports.mapPlaygroundTouchesToBitMoves = mapPlaygroundTouchesToBitMoves;
